export default {
	data() {
		return {
			tip_open: false
		}
	},
	methods: {
		tooltipToggle($event) {
			if ($event == 'toggle') {
				this.tip_open = !this.tip_open
			}
			else if ($event == 'close') {
				this.tip_open = false
			}
		}
	}
}